// @flow
import { TITLE_AND_TEXT } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { CORE_GET_COMMON_I18N } from 'Utils/request/requestDictionary';

export const titleAndTextResolver = {
  name: TITLE_AND_TEXT,
  resolve(appContext: AppContext = {}) {
    const query = `query {
      config {
        common {
          viewMore
          loadLess
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: CORE_GET_COMMON_I18N,
      strictErrors: false,
    });
  },
};
